/* @flow */
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Organization from 'entities/Organization';
import SupportDialog from 'support/components/SupportDialog.jsx';
import React from 'react';
import AffiliationStatus from './AffiliationStatus.jsx';

import './styles/DistrictAdminPending.scss';

const perks = [
  ['Direct, reliable messaging when you need it', require('assets/images/admin/megaphone.svg')],
  ['District communication in one place', require('assets/images/admin/computer-phone.svg')],
  ['Flexible features built for education', require('assets/images/admin/tools.svg')],
];

const DistrictAdminPending = React.createClass({
  propTypes: {
    organization: React.PropTypes.instanceOf(Organization).isRequired,
  },

  renderBox() {
    return (
      <Box
        size="small"
        full
        className="DistrictAdminPending-Box">
        <BoxBody divided={false} size="small">
          <ul>
            {perks.map(([message, src]) => (
              <li key={src}>
                <Image
                  src={src}
                  className="DistrictAdminPending-Box-perkImage"
                />
                {message}
              </li>
            ))
            }
          </ul>
        </BoxBody>
        <BoxBody divided>
          <div className="DistrictAdminPending-BottomText">
            Questions?
            {' '}
            <ModalTrigger modal={<SupportDialog />}>
              <Link>Contact us</Link>
            </ModalTrigger>
          </div>
        </BoxBody>
      </Box>
    );
  },

  render() {
    const orgName = this.props.organization.getName();
    return (
      <div className="DistrictAdminPending">
        <AffiliationStatus
          title={`${orgName} is coming soon!`}
          subtext="We're working on building district support for Remind.
          We'll send you an email as soon as it's ready!"
        />
        {this.renderBox()}
      </div>
    );
  },
});

export default DistrictAdminPending;



// WEBPACK FOOTER //
// ./src/organizations/components/DistrictAdminPending.jsx